import React, { Component } from "react";
import { connect } from "react-redux";
import { openModalDebitComp, debitsSelectedComp } from "../../actions";
import { bindActionCreators } from "redux";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Typography } from "@material-ui/core";
import imgPessoas from "../../assets/img/pessoas.svg";
import ButtonOK from "../../components/ButtonOK";
import { checkDebitsExist } from "../../helper/checkDebitsExist";

const styles = (theme) => ({
  container: {
    padding: "20px 15px",
    marginTop: "130px",
  },
  gridItem: {
    padding: 15,
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
  },
  message: {
    width: "100%",
    fontSize: 18,
  },
  imgPessoas: {
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
});

export class PaymentCardConfirmation extends Component {
  componentDidMount() {
    checkDebitsExist(this.props);
  }

  render() {
    const { classes } = this.props;

    return (
      <div>
        <Grid container className={classes.container}>
          <Grid item xs={12} sm={4} md={5} className={classes.gridItem}>
            <Typography variant="h2" component="h1" color="textSecondary">
              Quase lá!
            </Typography>
            <Typography
              variant="h5"
              component="h3"
              color="textSecondary"
              className={classes.message}
            >
              <p>
              O reconhecimento do pagamento pode demorar até 01 dia útil. Estamos aguardando o processamento do seu Banco.
              </p>
              
              <p>
              Recomendamos que retorne sua consulta em nosso site após este prazo.
              </p>
            </Typography>

            <ButtonOK />
          </Grid>

          <Grid item xs={12} sm={8} md={7} className={classes.gridItem}>
            <img
              src={imgPessoas}
              className={classes.imgPessoas}
              alt="Imagem de Pessoas"
            />
          </Grid>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (store) => ({
  debitsSelectedValue: store.cardDebitState.debitsSelectedValue,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ openModalDebitComp, debitsSelectedComp }, dispatch);

export default withStyles(styles, { withTheme: true })(
  connect(mapStateToProps, mapDispatchToProps)(PaymentCardConfirmation)
);
